export default {
  methods: {
    doAction(action) {
      switch (action) {
        case "start":
          this.gotoStart();
          return;
        case "help-center":
          this.gotoHelpCenter();
          return;
        case "upgrade":
          this.gotoUpgrade();
          return;
        case "open-tutorial":
          this.openTutorials();
          return;
        default:
          window.open(action, "_blank");
          return;
      }
    },
    gotoStart() {
      this.openStartedGuide();
    },
    gotoHelpCenter() {
      this.$chatbox.show();
    },
    gotoUpgrade() {
      this.$router.replace({ name: "Pricing" });
    },
    openTutorials() {
      this.$router.replace({ name: "Tutorials" });
    }
  }
};
